<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clip-rule="evenodd"
      d="m12.585 13.899-3.242.472.463-3.3 8.339-8.485a1.942 1.942 0 0 1 2.78 0 2.025 2.025 0 0 1 0 2.828l-8.34 8.485Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.224 14v6.667c0 .736-.587 1.333-1.31 1.333H3.81c-.723 0-1.31-.597-1.31-1.333V7.334c0-.736.587-1.333 1.31-1.333h6.552"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
